<div class="cipo--height--full" fxLayout="column">
    <div fxFlex="grow">
        <cdk-virtual-scroll-viewport
            cipoKeyboardList
            [itemCount]="rows()?.length ?? 0"
            class="cipo--height--full"
            (scrolledIndexChange)="onScrollIndexChange()"
            #viewport
            data-testid="infinite-data-list-scroll">
            @if (tableColumns().length) {
                <table
                    #table
                    mat-table
                    data-testid="datalist-table datalist-table-infinite"
                    recycleRows
                    fixedLayout
                    [trackBy]="trackByRow"
                    [dataSource]="rows()"
                    class="cipo-table"
                    [ngClass]="{ 'hide-footer': !loading() && !rows()?.length }"
                    matSort
                    [matSortActive]="options()?.sort?.active"
                    [matSortDirection]="options()?.sort?.direction"
                    (matSortChange)="tableSortChanged($event)">
                    <ng-container matColumnDef="select">
                        @if (options().selectable) {
                            <th
                                mat-header-cell
                                data-testid="datalist-header-cell datalist-header-cell-select"
                                *matHeaderCellDef
                                [style.width]="'50px'">
                                <span class="cdk-visually-hidden">{{ "a11y.dataList.selectColumn" | translate }}</span>
                                <mat-checkbox
                                    data-testid="datalist-header-cell-checkbox-select-all"
                                    [aria-label]="'a11y.dataList.selectAll' | translate"
                                    (change)="$event ? toggleAllRows() : null"
                                    [checked]="selection().hasValue() && isAllSelected()"
                                    [indeterminate]="selection().hasValue() && !isAllSelected()"
                                    [disabled]="selectAllDisabled()"></mat-checkbox>
                            </th>
                            <td
                                mat-cell
                                data-testid="datalist-cell datalist-cell-select"
                                *matCellDef="let row"
                                (click)="$event.stopPropagation()">
                                <mat-checkbox
                                    data-testid="datalist-cell-checkbox-select-one"
                                    [aria-label]="'a11y.dataList.selectRow' | translate"
                                    [tabIndex]="-1"
                                    (click)="checked()"
                                    (change)="$event ? selection().toggle(row) : null"
                                    [checked]="selection().isSelected(row)"
                                    [disabled]="row.selectable === false"></mat-checkbox>
                            </td>
                        } @else {
                            <th
                                mat-header-cell
                                data-testid="datalist-header-cell datalist-header-cell-select"
                                *matHeaderCellDef
                                [style.width]="'50px'"></th>
                            <td mat-cell data-testid="datalist-cell datalist-cell-select" *matCellDef="let row"></td>
                        }
                    </ng-container>

                    @for (column of tableColumns(); track column) {
                        <ng-container [matColumnDef]="column.name">
                            <th
                                cipoResizeColumn
                                mat-header-cell
                                [attr.data-testid]="'datalist-header-cell datalist-header-cell-' + column.name"
                                *matHeaderCellDef
                                mat-sort-header
                                disableClear
                                [class]="
                                    !column.align
                                        ? column.displayFormatId === DISPLAY_FORMAT.Number
                                            ? 'align--end'
                                            : ''
                                        : 'align--' + column.align
                                "
                                [disabled]="!column.sortable"
                                [style.width]="totalWidth ? (100 / totalWidth) * (column.width ?? 1) + '%' : 'auto'"
                                [title]="column.displayName | translate">
                                @if (column.srOnlyLabel) {
                                    <span class="cdk-visually-hidden">{{ column.srOnlyLabel | translate }}</span>
                                    <span class="cipo--text--ellipsed p-r-sm" aria-hidden="true">
                                        {{ column.displayName | translate }}
                                    </span>
                                } @else {
                                    <span class="cipo--text--ellipsed p-r-sm">
                                        {{ column.displayName | translate }}
                                    </span>
                                }
                            </th>

                            <td
                                mat-cell
                                [attr.data-testid]="'datalist-cell datalist-cell-' + column.name"
                                *matCellDef="let row"
                                [style.textAlign]="column.align">
                                <div class="dl-cell">
                                    @if (column["showColorCode"] && !row.empty) {
                                        <span
                                            class="color-code-wrapper dl-cell__color"
                                            [style.backgroundColor]="row | getColorCode"></span>
                                    }
                                    <cipo-table-cell
                                        [row]="row"
                                        class="dl-cell__grow"
                                        [column]="column"
                                        [noDataPlaceholder]="options().noDataPlaceholder"
                                        data-testid="datalist-cell-datalist-cell-cell" />
                                </div>
                            </td>
                        </ng-container>
                    }
                    @for (footerRow of footerRows(); track footerRow.key) {
                        <ng-container [matColumnDef]="footerRow.key.toString()">
                            <td
                                mat-footer-cell
                                *matFooterCellDef
                                [attr.data-testid]="
                                    'datalist-footer-cell datalist-footer-cell-' + footerRow.key.toString()
                                "
                                class="cipo--text-weight--bold cipo--text-size--sm">
                                @if (footerRow.label) {
                                    {{ "SqlAggregateFunctionType." + footerRow.label | translate }}
                                }
                            </td>
                        </ng-container>
                        @for (column of tableColumns(); track column.id) {
                            @let footerCellKey = footerRow.key + "_" + column.id;
                            <ng-container [matColumnDef]="footerCellKey">
                                <td
                                    mat-footer-cell
                                    *matFooterCellDef
                                    [attr.data-testid]="'datalist-footer-cell datalist-footer-cell-' + footerCellKey">
                                    @if (footerRow.key === FOOTER_KEYS.COUNT && !footerRow.empty) {
                                        <p class="cipo--text--end">{{ footerRow[column.name] }}</p>
                                    } @else {
                                        <cipo-table-cell [column]="column" [row]="footerRow" noDataPlaceholder=" " />
                                    }
                                </td>
                            </ng-container>
                        }
                    }
                    <ng-container matColumnDef="footer_actions">
                        <td
                            mat-footer-cell
                            *matFooterCellDef
                            data-testid="datalist-footer-cell datalist-footer-cell-footer_actions"></td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th
                            mat-header-cell
                            data-testid="datalist-header-cell datalist-header-cell-actions"
                            *matHeaderCellDef>
                            <span class="cdk-visually-hidden">{{ "a11y.dataList.actionsColumn" | translate }}</span>
                        </th>
                        <td mat-cell data-testid="datalist-cell datalist-cell-actions" *matCellDef="let row">
                            <cipo-table-row-actions
                                [row]="row"
                                [actions]="options().actions(row)"
                                [hasLeftIcons]="hasLeftIcons()"
                                [hasRightIcons]="hasRightIcons()"
                                [triggerTabIndex]="-1"
                                (actionSelected)="selectAction($event, row)" />
                        </td>
                    </ng-container>

                    <tr
                        mat-header-row
                        data-testid="datalist-header-row"
                        *matHeaderRowDef="displayedColumns(); sticky: true"></tr>

                    <tr
                        mat-row
                        *matRowDef="let row; let i = index; columns: displayedColumns()"
                        data-testid="datalist-row"
                        [attr.data-list-index]="i"
                        [attr.tabindex]="!row['empty'] && options().clickableRows ? -1 : null"
                        (click)="!row['empty'] && options().clickableRows && rowClick(row, $event)"
                        (keydown.enter)="onRowKey($event, row)"
                        [ngClass]="
                            !row['empty'] && options().clickableRows
                                ? [
                                      'cipo--cursor--pointer',
                                      'cipo-bg-hover--' + (row['hoverColor'] ?? 'primary-200'),
                                      row['backgroundColor'] ? 'cipo-bg--' + row['backgroundColor'] : '',
                                      row['customClass'] ? row['customClass'] : '',
                                  ]
                                : ''
                        "></tr>
                    @for (footer of footerRows(); track footer.key) {
                        <tr
                            mat-footer-row
                            [attr.data-testid]="'datalist-footer-row datalist-footer-row-' + footer.key.toString()"
                            *matFooterRowDef="footerColumns()[$index]; sticky: true"></tr>
                    }
                </table>
            }
            @if (!loading() && !rows()?.length) {
                <div class="m-t-xl">
                    <cipo-not-found />
                </div>
            }
        </cdk-virtual-scroll-viewport>
    </div>

    @if (loadedRowsCount() && !loading()) {
        <p class="cipo--text--end m-r-xl" fxFlex="none" [attr.data-testid]="'infinite-datalist-items-loaded'">
            {{
                "general.table.itemsLoaded"
                    | translate: { loaded: loadedRowsCount(), total: options().pagination.length }
            }}
        </p>
    }
</div>
